module.exports = __webpack_public_path__ + "static/media/xl-cta-pattern-left.6ca3fc20.svg";